
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ShieldCheck, Mail } from 'lucide-react';

const PrivacidadeScreen = () => {
    const navigate = useNavigate();

    return (
        <div className="p-6 bg-white h-full overflow-y-auto text-left">
            <div className="flex items-center mb-8 sticky top-0 bg-white py-2 z-10 border-b border-gray-50">
                <button onClick={() => navigate(-1)} className="p-2 rounded-full hover:bg-gray-100 mr-4 transition-colors">
                    <ArrowLeft size={24} className="text-gray-700" />
                </button>
                <h1 className="text-xl font-black text-gray-800 uppercase tracking-tighter">Política de Privacidade</h1>
            </div>

            <div className="space-y-8 pb-20">
                <div className="flex items-center space-x-3 text-emerald-600 bg-emerald-50 p-4 rounded-2xl border border-emerald-100">
                    <ShieldCheck size={32} />
                    <p className="text-xs font-bold leading-tight uppercase tracking-wider">Compromisso T-SERVI com seus dados e segurança</p>
                </div>

                <section>
                    <h2 className="text-sm font-black text-blue-600 uppercase mb-3 tracking-widest">1. Identificação</h2>
                    <p className="text-sm text-gray-600 leading-relaxed font-medium">
                        Esta Política de Privacidade refere-se à plataforma T-SERVI, identificada para fins de registro de marca como <span className="text-gray-900 font-bold">T-SERVI Autônomos e Especializados</span>.
                    </p>
                </section>

                <section>
                    <h2 className="text-sm font-black text-blue-600 uppercase mb-3 tracking-widest">2. Compromisso com a Privacidade</h2>
                    <p className="text-sm text-gray-600 leading-relaxed font-medium">
                        A T-SERVI respeita a privacidade dos usuários e trata dados pessoais conforme a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).
                    </p>
                </section>

                <section>
                    <h2 className="text-sm font-black text-blue-600 uppercase mb-3 tracking-widest">3. Dados Coletados</h2>
                    <p className="text-sm text-gray-500 font-bold mb-3">Podemos coletar:</p>
                    <ul className="grid grid-cols-2 gap-2">
                        {['Nome Completo', 'E-mail', 'Telefone', 'Localização aproximada', 'Histórico de serviços', 'Mensagens do chat'].map((item, i) => (
                            <li key={i} className="bg-gray-50 px-3 py-2 rounded-xl text-[11px] font-bold text-gray-700 border border-gray-100 flex items-center">
                                <div className="w-1 h-1 bg-blue-400 rounded-full mr-2"></div> {item}
                            </li>
                        ))}
                    </ul>
                </section>

                <section>
                    <h2 className="text-sm font-black text-blue-600 uppercase mb-3 tracking-widest">4. Finalidade do Uso</h2>
                    <p className="text-sm text-gray-500 font-bold mb-3">Os dados são utilizados para:</p>
                    <div className="space-y-2">
                        {[
                            'Funcionamento técnico da plataforma',
                            'Conexão direta entre clientes e SERVIs',
                            'Melhoria contínua da experiência do usuário',
                            'Segurança e prevenção de fraudes'
                        ].map((item, i) => (
                            <div key={i} className="text-sm text-gray-600 flex items-start">
                                <span className="mr-2 text-blue-500 font-black">•</span> {item}
                            </div>
                        ))}
                    </div>
                </section>

                <section>
                    <h2 className="text-sm font-black text-blue-600 uppercase mb-3 tracking-widest">5. Compartilhamento de Dados</h2>
                    <p className="text-sm text-gray-600 leading-relaxed font-medium">
                        Os dados <span className="text-red-500 font-bold">não são vendidos</span>. Podem ser compartilhados apenas:
                    </p>
                    <div className="mt-3 space-y-2 bg-gray-50 p-4 rounded-2xl border border-gray-100 italic">
                        <p className="text-xs text-gray-600">• Entre cliente e SERVI durante a intermediação de serviços.</p>
                        <p className="text-xs text-gray-600">• Quando exigido por lei ou ordem judicial.</p>
                    </div>
                </section>

                <section>
                    <h2 className="text-sm font-black text-blue-600 uppercase mb-3 tracking-widest">6. Armazenamento e Segurança</h2>
                    <p className="text-sm text-gray-600 leading-relaxed font-medium">
                        Os dados são armazenados em ambientes seguros, com medidas técnicas e organizacionais para proteção contra acessos não autorizados.
                    </p>
                </section>

                <section>
                    <h2 className="text-sm font-black text-blue-600 uppercase mb-3 tracking-widest">7. Direitos do Usuário</h2>
                    <p className="text-sm text-gray-500 font-bold mb-3">O usuário pode, a qualquer momento:</p>
                    <div className="grid grid-cols-1 gap-2">
                        {['Acessar seus dados pessoais', 'Solicitar correção de informações', 'Solicitar a exclusão definitiva da conta'].map((item, i) => (
                            <div key={i} className="bg-blue-50/50 px-4 py-3 rounded-2xl text-xs font-bold text-blue-800 border border-blue-100">
                                {item}
                            </div>
                        ))}
                    </div>
                </section>

                <section>
                    <h2 className="text-sm font-black text-blue-600 uppercase mb-3 tracking-widest">8. Alterações</h2>
                    <p className="text-sm text-gray-600 leading-relaxed font-medium italic">
                        Esta Política poderá ser atualizada periodicamente para refletir melhorias no sistema.
                    </p>
                </section>

                <section className="bg-gray-900 p-6 rounded-[2.5rem] text-center">
                    <Mail className="mx-auto text-blue-400 mb-3" size={32} />
                    <h2 className="text-sm font-black text-white uppercase mb-1 tracking-widest">9. Contato</h2>
                    <p className="text-blue-400 font-black text-xs">suporte.tservi@gmail.com</p>
                </section>
            </div>
        </div>
    );
};

export default PrivacidadeScreen;
